import React, { useState, useCallback } from "react";
import {
  useNavigate,
  useRouteLoaderData,
  useRevalidator,
} from "react-router-dom";
import { updateBooks } from "API/swesum";
import usePost from "Hooks/usePost";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import Paper from "Components/UI/Paper";
import { BooksForm } from "Components/books/BooksForm";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function BooksCard() {
  const { books, allBooks, files } = useRouteLoaderData("books");

  const { openSuccess, openError } = usePopupNotificationContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();
  const revalidator = useRevalidator();

  const updateBooksReq = usePost({
    mtnFunc: (body) => updateBooks(books.Id, body),
    onError: () => {
      openError("Ett fel har uppstått", 5000);
    },
    onSuccess: (data) => {
      openSuccess(`Sparat! ${data.ParseMessage && data.ParseMessage} `, 3000);
      revalidator.revalidate();
      setEditMode(false);
    },
  });

  const [formData, setFormData] = useState({
    Id: books.Id ? books.Id : "",
    DebitAccountChartId: books.DebitAccountChartId
      ? books.DebitAccountChartId
      : null,
    DebetAmount: books.DebetAmount ? books.DebetAmount : 0,
    KreditAmount: books.KreditAmount ? books.KreditAmount : 0,
    ParseStatus: books.ParseStatus ? books.ParseStatus : "",
    ParseMessage: books.ParseMessage ? books.ParseMessage : "",
    SystemStatus: books.SystemStatus ? books.SystemStatus : "",
    CreateTime: books.CreateTime ? books.CreateTime : "",
    CreditAccountChartId: books.CreditAccountChartId
      ? books.CreditAccountChartId
      : null,
    BookGroupId: books.BookGroupId ? books.BookGroupId : "",
    BookDate: books.BookDate ? books.BookDate : "",
    FileId: books.FileId ? books.FileId : "",
  });
  const closeDialog = () => {
    setDialogOpen(false);
  };

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  return (
    <>
      <Paper>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
            Bokföringskort - {books.Id}
          </Typography>
        </Box>
        <BooksForm
          formData={formData}
          FORM_MODE={editMode ? "EDIT" : "LOCKED"}
          handleInputChange={handleInputChange}
          allBooks={files}
        />

        <Grid
          item
          xs={12}
          sx={{ marginTop: 2, display: "flex", justifyContent: "flex-end" }}
        >
          {editMode ? (
            <>
              <Button
                size="small"
                onClick={() => setEditMode(false)}
                sx={{ ml: 1, display: editMode ? "block" : "none" }}
              >
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => updateBooksReq.post(formData)}
                sx={{ ml: 2 }}
                variant="contained"
              >
                Spara
              </Button>
            </>
          ) : (
            <>
              <Button size="small" onClick={() => navigate(-1)}>
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => setEditMode(true)}
                variant="contained"
                sx={{ ml: 2, display: editMode ? "none" : "block" }}
              >
                Editera
              </Button>
            </>
          )}
        </Grid>
      </Paper>
    </>
  );
}
